import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["registration", "paypal"]

  connect() {
    this.firstLoad = true
    this.hidePaypal()
    this.registrationTargets.forEach((node) => {
      node.addEventListener("load", () => this.onRegistrationLoad())
    })
  }

  onRegistrationLoad() {
    if (this.firstLoad) {
      this.firstLoad = false
      return
    }
    this.showPaypal()
  }

  hidePaypal() {
    this.paypalTargets.forEach((node) => (node.style.display = "none"))
  }

  showPaypal() {
    this.paypalTargets.forEach((node) => (node.style.display = ""))
  }
}
